import moment from 'moment';
import { DATE_INPUT_FORMAT } from './input-formats';

/**
 * Strictly parses a `DATE_INPUT_FORMAT` value. A typed date input can still hold a
 * year beyond 9999 (e.g. '20261-01-01'), which breaks string comparison and
 * isn't a valid `DATE_INPUT_FORMAT` value, so it parses as invalid.
 */
export const parseDate = (value: string | null | undefined) =>
  moment(value ?? '', DATE_INPUT_FORMAT, true);

/**
 * Dates from `start` to `end` (inclusive) falling on one of `days`, where 0 is
 * Monday and 6 is Sunday. Empty if either date is invalid or out of order.
 */
export const enumerateSelectedDates = (
  start: string,
  end: string,
  days: number[]
) => {
  const startMoment = parseDate(start);
  const endMoment = parseDate(end);

  if (
    !startMoment.isValid() ||
    !endMoment.isValid() ||
    endMoment.isBefore(startMoment)
  ) {
    return [];
  }

  const dates = Array.from({
    length: endMoment.diff(startMoment, 'days') + 1,
  }).map((_, i) => startMoment.clone().add(i, 'days'));

  const selectedDaysOfWeek = new Set(days);

  return dates.filter((date) => selectedDaysOfWeek.has(date.isoWeekday() - 1));
};
